import * as React from 'react';
import cn from 'classnames';

import { Business as BusinessRoot } from '../../../../../../CheckoutAdditionalService/components';
import { GdsAggregationServiceGroup, GdsAggregationServiceVip } from '../../../../../types';
import { useTheme } from '../../../../../../theme';

interface Props {
	service?: GdsAggregationServiceGroup;
	hideCard?: boolean;
	segmentId?: string;
}

const Business: React.FC<Props> = ({ service, hideCard, segmentId }) => {
	const theme = useTheme('Checkout').ServicesAggregationPage;

	return (
		<div className={cn({ [theme.hideServiceCard]: hideCard })}>
			<BusinessRoot
				services={service?.services as GdsAggregationServiceVip[]}
				segmentId={segmentId}
				aggregationIcons={['Amenity/WiFi', 'Services/Meal']}
				aggregationMode
			/>
		</div>
	);
};

export default Business;
